/*
 * @Author: lizhigang
 * @Date: 2025-12-25
 * @Company: www.smm.cn
 * @Description: 认证页面专用 ConfigProvider，提供统一的主题配置
 */
"use client"

import { getAntdLocale } from "@repo/shared"
import { useLocale } from "next-intl"
import React from "react"
import { App, ConfigProvider } from "antd"

interface AuthConfigProviderProps {
  children: React.ReactNode
}

/**
 * 认证页面专用的 ConfigProvider
 * 统一配置登录、注册、忘记密码页面的主题样式
 */
export function AuthConfigProvider({ children }: AuthConfigProviderProps) {
  const hookLocale = useLocale()
  const locale = hookLocale || "en"
  const antdLocale = getAntdLocale(locale)

  const fontFamilyMap: Record<string, string> = {
    th: "var(--font-noto-sans-thai), var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif",
  }
  const fontFamily = fontFamilyMap[locale] ?? "var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif"
  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        token: {
          fontFamily,
          colorPrimary: "#d7000f",
          borderRadius: 2,
          controlHeight: 40,
          fontSize: 16,
          controlInteractiveSize: 14,
          colorFillTertiary: "#F5F6F9",
        },
        components: {
          Form: {
            itemMarginBottom: 20,
          },
          Select: {
            activeBorderColor: "#0C1019",
            hoverBorderColor: "#0C1019",
            optionSelectedBg: "transparent",
            optionSelectedColor: "#d7000f",
            activeOutlineColor: "transparent",
            optionActiveBg: "rgba(245, 246, 249, .8)",
            // optionSelectedBg: "#F5F6F9",
            // optionSelectedColor: "#0C1019",
          },
          Input: {
            activeBorderColor: "#0C1019",
            hoverBorderColor: "#0C1019",
            activeShadow: "transparent",
          },
          Message: {
            contentBg: "#0C1019",
            contentPadding: "14px 16px",
          },
        },
      }}
    >
      <App>{children}</App>
    </ConfigProvider>
  )
}
